import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Loader from "./Loader";
import { BsFillPlayFill, BsInfoLg } from "react-icons/bs";
import "./Login.css";
import Cookies from "js-cookie";


//triva faith banner code
const CustomSlide = ({ img, isFaith }) => {
  //   const handleFaithRedirect = () => {
  //   const msisdn = Cookies.get("msisdn"); // change if cookie name different

  //   if (!msisdn) {
  //     console.log("MSISDN not found in cookies");
  //     return;
  //   }

  //   const redirectUrl = `https://faithquiztrivia.com/?msisdn=${encodeURIComponent(msisdn)}`;
  //   window.location.href = redirectUrl;
  // };
if (isFaith) {
    const handleClick = () => {
    // 🚨 Only redirect if it's static banner
    if (!img.isStatic) return;

    const msisdn = Cookies.get("msisdn");

    if (!msisdn) {
      console.log("MSISDN not found in cookies");
      return;
    }

    const redirectUrl = `https://faithquiztrivia.com/?msisdn=${encodeURIComponent(msisdn)}`;
    window.location.href = redirectUrl;

    //  const redirectUrl = `https://faithquiztrivia.com/?msisdn=${msisdn}`;
    // window.location.href = redirectUrl;
  };

  return (
    <div
      className="w-full lg:h-[70vh] h-auto bg-black flex items-center justify-center cursor-pointer overflow-hidden"
      onClick={handleClick}
    >
      <img
        src={img.imgurl}
        alt="faith-banner"
        // className="w-full h-[250px] md:h-[250px] object-fit rounded-lg shadow-lg"/>
 className="w-full h-full object-contain"      />
    </div>
  );
}
  // 🔹 Normal Service Layout (Non-Faith)
  return (
    <div className="p-4">
      <img
        src={img.imgurl}
        alt="banners"
        className="w-full h-[250px] object-cover rounded-lg shadow-lg"
        // className="w-full h-[250px] md:h-[250px] object-fit rounded-lg shadow-lg"
        // className="w-full h-[250px] md:h-[250px] object-fit rounded-lg shadow-lg"
      />

     {/* Centered button container */}
    <div 
    // className="mt-[-8px] text-center " 
    class="mt-[-8px] text-center "
    style={{backgroundColor: 'rgba(0, 0, 0, 0.1)',backdropFilter: 'blur(20px)'}}>
    {/* // style={{ backgroundColor: 'rgba(0, 0, 0, 0.1)', backdropFilter: 'blur(20px)' }}> */}
       <button className="bg-white  text-black px-4 py-2 mx-2 rounded-md">
        <div className='flex'>
        <BsFillPlayFill className='mt-1'/> Play 
        </div>
    
     </button>
      <button className="bg-white text-black px-4 py-2 rounded-md">
      <div className='flex'>
        <BsInfoLg className='mt-1'/> Info         
         </div>
       </button>
    </div>
</div>
  );
};



const DataCarousel = ({ banner = [], isFaith = false }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setData(Array.isArray(banner) ? banner : []);
    setLoading(false);
  }, [banner]);

  // 🔥 Faith Redirect Function
  const handleFaithRedirect = () => {
    const msisdn = Cookies.get("msisdn"); // change name if different

    if (!msisdn) {
      console.log("MSISDN not found in cookies");
      return;
    }

    // const redirectUrl = `https://faithquiztrivia.com/?msisdn=${encodeURIComponent(msisdn)}`;
    const redirectUrl = `https://faithquiztrivia.com/?msisdn=${msisdn}`;

    // redirect in same tab
    window.location.href = redirectUrl;

    // if you want new tab:
    // window.open(redirectUrl, "_blank");
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay:true,
      autoplaySpeed: 3000,   // 3 seconds

    // autoplay: !isFaith, // disable autoplay for faith
  };

  if (loading) return <Loader />;
  if (!data.length) return null;

  return (
    <div className={`${isFaith ? "w-full" : "container mx-auto"} slider-main`}>
      <Slider {...settings}>
        {data.map((img, index) => (
          <CustomSlide
            key={index}
            img={img}
            isFaith={isFaith}
            onFaithClick={handleFaithRedirect}
          />
        ))}
      </Slider>
    </div>
  );
};

export default DataCarousel;







// import React, { useState, useEffect } from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import Loader from "./Loader";
// import { BsFillPlayFill, BsInfoLg } from "react-icons/bs";
// import "./Login.css";
// import Cookies from "js-cookie";


// //triva faith banner code
// const CustomSlide = ({ img, isFaith }) => {
//     const handleFaithRedirect = () => {
//     const msisdn = Cookies.get("msisdn"); // change if cookie name different

//     if (!msisdn) {
//       console.log("MSISDN not found in cookies");
//       return;
//     }

//     const redirectUrl = `https://faithquiztrivia.com/?msisdn=${encodeURIComponent(msisdn)}`;
//     window.location.href = redirectUrl;
//   };
//   if (isFaith) {
//     return (
//       <>
//         {/* ✅ DESKTOP VERSION */}
//         <div className="hidden md:flex relative w-full min-h-screen items-center justify-center overflow-hidden"  onClick={handleFaithRedirect}
// >
          
//           {/* Blurred Background */}
        
        
//           <div
//   className="absolute top-0 left-0 w-full h-full bg-center bg-cover blur-2xl"
//   style={{
//     backgroundImage: `url(${img.imgurl})`,
//     opacity: 0.5,
//   }}
// ></div>

//           {/* Center Image */}
//           <img
//             src={img.imgurl}
//             alt="faith-banner"
//             className="relative z-10 max-h-[90vh] object-contain rounded-lg shadow-2xl"
//           />
//         </div>

//         {/* ✅ MOBILE VERSION (Old Layout) */}
//         <div className="md:hidden p-4" onClick={handleFaithRedirect}
// >
          
//           <img
//             src={img.imgurl}
//             alt="faith-banner"
//             className="w-full h-auto object-contain rounded-lg shadow-lg"
//           />
//         </div>
//       </>
//     );
//   }

//   // 🔹 Normal Service Layout (Non-Faith)
//   return (
//     <div className="p-4">
//       <img
//         src={img.imgurl}
//         alt="banners"
//         // className="w-full h-[250px] object-cover rounded-lg shadow-lg"
//         className="w-full h-[250px] md:h-[250px] object-fit rounded-lg shadow-lg"
//       />

//      {/* Centered button container */}
//     <div className="mt-[-8px] text-center " style={{ backgroundColor: 'rgba(0, 0, 0, 0.1)', backdropFilter: 'blur(20px)' }}>
//        <button className="bg-white  text-black px-4 py-2 mx-2 rounded-md">
//         <div className='flex'>
//         <BsFillPlayFill className='mt-1'/> Play 
//         </div>
    
//      </button>
//       <button className="bg-white text-black px-4 py-2 rounded-md">
//       <div className='flex'>
//         <BsInfoLg className='mt-1'/> Info         
//          </div>
//        </button>
//     </div>
// </div>
//   );
// };



// const DataCarousel = ({ banner = [], isFaith = false }) => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     setData(Array.isArray(banner) ? banner : []);
//     setLoading(false);
//   }, [banner]);

//   // 🔥 Faith Redirect Function
//   const handleFaithRedirect = () => {
//     const msisdn = Cookies.get("msisdn"); // change name if different

//     if (!msisdn) {
//       console.log("MSISDN not found in cookies");
//       return;
//     }

//     const redirectUrl = `https://faithquiztrivia.com/?msisdn=${encodeURIComponent(msisdn)}`;

//     // redirect in same tab
//     window.location.href = redirectUrl;

//     // if you want new tab:
//     // window.open(redirectUrl, "_blank");
//   };

//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 800,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay:true,
//       autoplaySpeed: 2000,   // 3 seconds

//     // autoplay: !isFaith, // disable autoplay for faith
//   };

//   if (loading) return <Loader />;
//   if (!data.length) return null;

//   return (
//     <div className={`${isFaith ? "w-full" : "container mx-auto"} slider-main`}>
//       <Slider {...settings}>
//         {data.map((img, index) => (
//           <CustomSlide
//             key={index}
//             img={img}
//             isFaith={isFaith}
//             onFaithClick={handleFaithRedirect}
//           />
//         ))}
//       </Slider>
//     </div>
//   );
// };

// export default DataCarousel;





















// import React, { useState, useEffect } from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import Loader from "./Loader";
// import { BsFillPlayFill, BsInfoLg } from "react-icons/bs";
// import "./Login.css";
// import Cookies from "js-cookie";


// // const CustomSlide = ({ img, isFaith }) => {
// //   return (
// //     <div className="p-4">
// //       {/* <img
// //         src={img.imgurl}
// //         alt="banners"
// //         className="w-full h-[250px] md:h-[250px] object-cover rounded-lg shadow-lg"
// //       /> */}

// //       <img
// //   src={img.imgurl}
// //   alt="banners"
// //   className={`w-full ${
// //     isFaith
// //       ? "h-auto object-contain"
// //       : "h-[250px] md:h-[250px] object-cover"
// //   } rounded-lg shadow-lg`}
// // />

// //       {/* ❌ Hide buttons for faith */}
// //       {!isFaith && (
// //         <div
// //           className="mt-[-8px] text-center"
// //           style={{
// //             backgroundColor: "rgba(0,0,0,0.1)",
// //             backdropFilter: "blur(20px)",
// //           }}
// //         >
// //           <button className="bg-white text-black px-4 py-2 mx-2 rounded-md">
// //             <div className="flex items-center">
// //               <BsFillPlayFill className="mr-1" /> Play
// //             </div>
// //           </button>

// //           <button className="bg-white text-black px-4 py-2 rounded-md">
// //             <div className="flex items-center">
// //               <BsInfoLg className="mr-1" /> Info
// //             </div>
// //           </button>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };


// // const CustomSlide = ({ img, isFaith }) => {
// //   if (isFaith) {
// //     return (
// //       <div className="relative w-full h-screen flex items-center justify-center overflow-hidden">
        
// //         {/* 🔹 Blurred Background */}
// //         <div
// //           className="absolute inset-0 bg-center bg-cover blur-xl scale-110"
// //           style={{
// //             backgroundImage: `url(${img.imgurl})`,
// //             opacity: 0.4,
// //           }}
// //         ></div>

// //         {/* 🔹 Main Center Image */}
// //         <img
// //           src={img.imgurl}
// //           alt="faith-banner"
// //           className="relative z-10 max-h-[90vh] object-contain rounded-lg shadow-2xl"
// //         />
// //       </div>
// //     );
// //   }

// //   // 🔹 Normal Service Layout
// //   return (
// //     <div className="p-4">
// //       <img
// //         src={img.imgurl}
// //         alt="banners"
// //         className="w-full h-[250px] object-cover rounded-lg shadow-lg"
// //       />

// //       <div
// //         className="mt-[-8px] text-center"
// //         style={{
// //           backgroundColor: "rgba(0,0,0,0.1)",
// //           backdropFilter: "blur(20px)",
// //         }}
// //       >
// //         <button className="bg-white text-black px-4 py-2 mx-2 rounded-md">
// //           Play
// //         </button>

// //         <button className="bg-white text-black px-4 py-2 rounded-md">
// //           Info
// //         </button>
// //       </div>
// //     </div>
// //   );
// // };

// //triva faith banner code
// const CustomSlide = ({ img, isFaith }) => {
//     const handleFaithRedirect = () => {
//     const msisdn = Cookies.get("msisdn"); // change if cookie name different

//     if (!msisdn) {
//       console.log("MSISDN not found in cookies");
//       return;
//     }

//     const redirectUrl = `https://faithquiztrivia.com/?msisdn=${encodeURIComponent(msisdn)}`;
//     window.location.href = redirectUrl;
//   };
//   if (isFaith) {
//     return (
//       <>
//         {/* ✅ DESKTOP VERSION */}
//         <div className="hidden md:flex relative w-full min-h-screen items-center justify-center overflow-hidden"  onClick={handleFaithRedirect}
// >
          
//           {/* Blurred Background */}
//           {/* <div
//             className="absolute inset-0 bg-center bg-cover blur-2xl"
//             style={{
//               backgroundImage: `url(${img.imgurl})`,
//               opacity: 0.5,
//             }}
//           ></div> */}
//           <div
//   className="absolute top-0 left-0 w-full h-full bg-center bg-cover blur-2xl"
//   style={{
//     backgroundImage: `url(${img.imgurl})`,
//     opacity: 0.5,
//   }}
// ></div>

//           {/* Center Image */}
//           <img
//             src={img.imgurl}
//             alt="faith-banner"
//             className="relative z-10 max-h-[90vh] object-contain rounded-lg shadow-2xl"
//           />
//         </div>

//         {/* ✅ MOBILE VERSION (Old Layout) */}
//         <div className="md:hidden p-4" onClick={handleFaithRedirect}
// >
          
//           <img
//             src={img.imgurl}
//             alt="faith-banner"
//             className="w-full h-auto object-contain rounded-lg shadow-lg"
//           />
//         </div>
//       </>
//     );
//   }

//   // 🔹 Normal Service Layout (Non-Faith)
//   return (
//     <div className="p-4">
//       <img
//         src={img.imgurl}
//         alt="banners"
//         // className="w-full h-[250px] object-cover rounded-lg shadow-lg"
//         className="w-full h-[250px] md:h-[250px] object-fit rounded-lg shadow-lg"
//       />

//      {/* Centered button container */}
//     <div className="mt-[-8px] text-center " style={{ backgroundColor: 'rgba(0, 0, 0, 0.1)', backdropFilter: 'blur(20px)' }}>
//        <button className="bg-white  text-black px-4 py-2 mx-2 rounded-md">
//         <div className='flex'>
//         <BsFillPlayFill className='mt-1'/> Play 
//         </div>
    
//      </button>
//       <button className="bg-white text-black px-4 py-2 rounded-md">
//       <div className='flex'>
//         <BsInfoLg className='mt-1'/> Info         
//          </div>
//        </button>
//     </div>
// </div>
//   );
// };

// //working carousel 
// // const DataCarousel = ({ banner = [], isFaith = false }) => {
// //   const [data, setData] = useState([]);
// //   const [loading, setLoading] = useState(true);

// //   useEffect(() => {
// //     setData(Array.isArray(banner) ? banner : []);
// //     setLoading(false);
// //   }, [banner]);

// //   const settings = {
// //     dots: true,
// //     infinite: true,
// //     speed: 800,
// //     slidesToShow: 1,
// //     slidesToScroll: 1,
// //     autoplay: !isFaith, // 🔥 optional: disable autoplay for faith
// //   };

// //   if (loading) return <Loader />;

// //   if (!data.length) return null;

// //   return (
// //     // <div className="container w-full mx-auto slider-main">
// //     <div className={`${isFaith ? "w-full" : "container mx-auto"} slider-main`}>
// //       <Slider {...settings}>
// //         {data.map((img, index) => (
// //           <CustomSlide key={index} img={img} isFaith={isFaith} />
// //         ))}
// //       </Slider>
// //     </div>
// //   );
// // };

// const DataCarousel = ({ banner = [], isFaith = false }) => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     setData(Array.isArray(banner) ? banner : []);
//     setLoading(false);
//   }, [banner]);

//   // 🔥 Faith Redirect Function
//   const handleFaithRedirect = () => {
//     const msisdn = Cookies.get("msisdn"); // change name if different

//     if (!msisdn) {
//       console.log("MSISDN not found in cookies");
//       return;
//     }

//     const redirectUrl = `https://faithquiztrivia.com/?msisdn=${encodeURIComponent(msisdn)}`;

//     // redirect in same tab
//     window.location.href = redirectUrl;

//     // if you want new tab:
//     // window.open(redirectUrl, "_blank");
//   };

//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 800,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay:true,
//       autoplaySpeed: 2000,   // 3 seconds

//     // autoplay: !isFaith, // disable autoplay for faith
//   };

//   if (loading) return <Loader />;
//   if (!data.length) return null;

//   return (
//     <div className={`${isFaith ? "w-full" : "container mx-auto"} slider-main`}>
//       <Slider {...settings}>
//         {data.map((img, index) => (
//           <CustomSlide
//             key={index}
//             img={img}
//             isFaith={isFaith}
//             onFaithClick={handleFaithRedirect}
//           />
//         ))}
//       </Slider>
//     </div>
//   );
// };

// export default DataCarousel;


// // import React, { useState, useEffect } from 'react';
// // import Slider from 'react-slick';
// // import 'slick-carousel/slick/slick.css';
// // import 'slick-carousel/slick/slick-theme.css';
// // import ndoto from '../assets/ndoto.jpg';
// // import Loader from './Loader';
// // import {BsFillPlayFill,BsInfoLg} from 'react-icons/bs'
// // import './Login.css';

// // const CustomSlide = ({ img,isFaith }) => {
// //   return (
// //     <div className="p-4">
// //     {/* You can customize the content of each slide here */}
// //     <img
// //       src={img.imgurl}
// //       alt={'banners'}
// //       className="w-full h-[250px] md:h-[250px] object-fit rounded-lg shadow-lg"
// //     />
// //     {/* Centered button container */}
// //     <div className="mt-[-8px] text-center " style={{ backgroundColor: 'rgba(0, 0, 0, 0.1)', backdropFilter: 'blur(20px)' }}>
// //       <button className="bg-white  text-black px-4 py-2 mx-2 rounded-md">
// //         <div className='flex'>
// //         <BsFillPlayFill className='mt-1'/> Play 
// //         </div>
    
// //       </button>
// //       <button className="bg-white text-black px-4 py-2 rounded-md">
// //       <div className='flex'>
// //         <BsInfoLg className='mt-1'/> Info 
// //         </div>
// //       </button>
// //     </div>
// //   </div>
// //   );
// // };

// // const DataCarousel = ({ banner }) => {
// //   const [data, setData] = useState([]);
// //   const [loading, setLoading] = useState(true);

// //   useEffect(() => {
// //     const bannerArray = Object.values(banner);
// //     setData(bannerArray);
// //     setLoading(false);
// //   }, [banner]);

// //   const settings = {
// //     dots: true,
// //     infinite: true,
// //     speed: 800,
// //     slidesToShow: 1,
// //     slidesToScroll: 1,
// //     autoplay: true,
// //     responsive: [
// //       {
// //         breakpoint: 1024,
// //         settings: {
// //           slidesToShow: 1,
// //           slidesToScroll: 1,
// //         },
// //       },
// //     ],
// //   };

// //   return (
// //     <div>
// //       {loading ? (
// //         <Loader />
        
// //       ) : (
// //         <div className="container w-full mx-auto slider-main">
// //           <Slider {...settings}>
// //             {data.map((img, index) => {
// //               return <CustomSlide key={index} img={img} />;
// //             })}
// //           </Slider>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default DataCarousel;















